<div class="template-area-details" [formGroup]="detailsFormGroup">
  <div class="details-grid">
    <sc-dictionary-field [model]="details.title" [defaultLabel]="'title'" style="grid-column: 1; grid-row: 1;"
      (dictionaryChanged)="onTitleDataDictionaryChanged($event)"
      [labelDictionaryKey]="'tmc-yard.entity.document-template-area.title'" [required]="false" [maxlength]="255">
    </sc-dictionary-field>
    <sc-dictionary-field [model]="details.help" [defaultLabel]="'help'" style="grid-column: 1; grid-row: 2;"
      (dictionaryChanged)="onHelpDataDictionaryChanged($event)"
      [labelDictionaryKey]="'tmc-yard.entity.document-template-area.help'" [required]="false" [maxlength]="255">
    </sc-dictionary-field>
    <mat-form-field style="grid-column: 1; grid-row: 3;">
      <input matInput name="columnCount" formControlName="columnCount" type="number" appPositiveInteger
        placeholder="{{'column count' | translate:['tmc-yard.entity.document-template-area.column-count', translationService.language]}}"
        [required]="true" [maxLength]="255">
    </mat-form-field>
    <mat-form-field style="grid-column: 1; grid-row: 4;">
      <mat-label>
        {{'choice' | translate: ['tmc-yard.entity.document-template-area.choice',
        translationService.language]}}
      </mat-label>
      <mat-select formControlName="choice">
        <mat-option value="{{null}}">
          {{''}}
        </mat-option>
        <mat-option *ngFor="let t of choiceOptions" value="{{t}}">
          {{t | translate: ['tmc-yard.entity.document-template-area.choice.'+t, translationService.language]}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field style="grid-column: 1; grid-row: 5;">
      <input matInput name="style" formControlName="style"
        placeholder="{{'style' | translate:['tmc-yard.entity.document-template-area.style', translationService.language]}}"
        [required]="true" [maxLength]="255">
    </mat-form-field>
    <div style="grid-column: 1; grid-row: 6;" class="align-right">
      <button mat-flat-button (click)="deleteArea()">
        <sc-icon iconClass="fa-trash"></sc-icon>
      </button>
    </div>
  </div>
</div>